import React from 'react';

import { Tabs, TabsContent, TabsList, TabsTrigger } from '#/components/ui';
import { Profile, Teams } from '..';

const ProfileMain = () => {
    return (
        <div className='py-5 bg-white rounded-lg shadow-md'>
            <Tabs defaultValue='profile' className=''>
                <div className='flex justify-between border-b-2 border-gray200 mx-5'>
                    <TabsList className='space-x-4'>
                        <TabsTrigger value='profile' className='text-2xl pb-4 px-1 font-semibold'>
                            Profile Settings
                        </TabsTrigger>
                        <TabsTrigger value='team-members' className='text-2xl pb-4 px-1 font-semibold'>
                            Team Members
                        </TabsTrigger>
                    </TabsList>
                </div>

                <TabsContent value='profile'>
                    <Profile />
                </TabsContent>
                <TabsContent value='team-members'>
                    <Teams />
                </TabsContent>
            </Tabs>
        </div>
    );
};

export { ProfileMain };
